
import React from 'react';

export const Dashboard: React.FC = () => {
  const stats = [
    { label: 'Total Websites', value: '12', trend: '+2 this month', color: 'indigo' },
    { label: 'Monthly Visitors', value: '45.2K', trend: '+12%', color: 'emerald' },
    { label: 'Leads Generated', value: '890', trend: '+5.4%', color: 'amber' },
    { label: 'Active Campaigns', value: '4', trend: 'Healthy', color: 'rose' },
  ];

  return (
    <div className="space-y-8 animate-in fade-in duration-500">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat) => (
          <div key={stat.label} className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200 hover:shadow-md transition-shadow">
            <p className="text-sm font-medium text-slate-500 mb-1">{stat.label}</p>
            <div className="flex items-baseline gap-2">
              <h3 className="text-3xl font-bold text-slate-900">{stat.value}</h3>
              <span className={`text-xs font-semibold ${stat.trend.includes('+') ? 'text-emerald-600' : 'text-slate-400'}`}>
                {stat.trend}
              </span>
            </div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 bg-white rounded-2xl border border-slate-200 p-8">
          <div className="flex items-center justify-between mb-8">
            <h3 className="text-lg font-bold">Recent Site Activity</h3>
            <button className="text-indigo-600 text-sm font-semibold">View All Logs</button>
          </div>
          <div className="space-y-6">
            {[1, 2, 3].map((i) => (
              <div key={i} className="flex items-center gap-4 border-b border-slate-50 pb-6 last:border-0 last:pb-0">
                <div className="w-10 h-10 bg-slate-100 rounded-full flex items-center justify-center text-slate-500">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path></svg>
                </div>
                <div className="flex-1">
                  <p className="text-sm font-semibold">Updated "Hero Section" on tech-startup.com</p>
                  <p className="text-xs text-slate-400">2 hours ago</p>
                </div>
                <span className="text-xs bg-indigo-50 text-indigo-600 font-bold px-2 py-1 rounded">Edited</span>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-slate-200 p-8">
          <h3 className="text-lg font-bold mb-6">Subscription Status</h3>
          <div className="bg-slate-50 rounded-xl p-4 mb-6">
             <div className="flex justify-between items-center mb-2">
               <span className="text-sm font-medium text-slate-600">Plan Usage</span>
               <span className="text-sm font-bold">75%</span>
             </div>
             <div className="w-full bg-slate-200 h-2 rounded-full overflow-hidden">
               <div className="bg-indigo-600 h-full w-[75%]"></div>
             </div>
          </div>
          <p className="text-xs text-slate-500 mb-6">You are using 15 out of 20 website slots. Upgrade to Enterprise for unlimited sites.</p>
          <button className="w-full bg-slate-900 text-white font-bold py-3 rounded-xl hover:bg-slate-800 transition-colors">
            Upgrade Plan
          </button>
        </div>
      </div>
    </div>
  );
};
